/* @flow */

import { getMembershipFlags } from '@e180/domain/lib/membership/util';
import { assertObject } from '@e180/util/lib/assert';

import type { Membership } from '@e180/domain/lib/membership/type';

export function isMembershipTermsAccepted(membership: Membership): boolean {
  // $FlowIssue
  return getMembershipFlags(membership).terms_optin;
}

export function isMembershipModerationOptinCompleted(
  membership: Membership,
): boolean {
  // $FlowIssue
  return getMembershipFlags(membership).moderation_optin_completed;
}

export function getMembershipGuidance(membership: Membership): ?Object {
  assertObject(membership, 'membership');

  // $FlowIssue
  const { guidance } = membership;

  return guidance && typeof guidance === 'object' ? { ...guidance } : {};
}

export function getMembershipGuidanceLabel(membership: Membership): ?string {
  assertObject(membership, 'membership');

  const guidance = getMembershipGuidance(membership);

  return guidance && guidance.label;
}

export function getMembershipGuidanceData(membership: Membership): ?Object {
  assertObject(membership, 'membership');

  const guidance = getMembershipGuidance(membership);

  return guidance && guidance.data;
}

export function getMembershipGuidanceCount(membership: Membership): ?number {
  assertObject(membership, 'membership');

  const data = getMembershipGuidanceData(membership);

  return data && data.count;
}

export function getMembershipGuidanceObjectId(membership: Membership): ?number {
  assertObject(membership, 'membership');

  const data = getMembershipGuidanceData(membership);

  return data && data.object_id;
}

export function getMembershipGuidanceSearch(membership: Membership): ?string {
  assertObject(membership, 'membership');

  const data = getMembershipGuidanceData(membership);

  return data && data.search;
}
